import { fetchJSON, fetchPOST } from "../Tools";

interface IDialogFields {
    pegelId: JQuery<HTMLElement>;
    threshold: JQuery<HTMLElement>,
    description: HTMLElement;
}

interface ITalsperreData {
    stationId: string;
    pegelId: string;
    threshold: number;
    description: string;
}

export default class EditTalsperreControl {
    protected dialog: JQuery<HTMLElement>;
    protected dialogFields: IDialogFields;
    protected talsperreId: string;

    constructor() {
        if (!document.querySelectorAll('.edit-talsperre-control').length) {
            return;
        }
        document.querySelectorAll('.edit-talsperre-control').forEach(el => {
            el.addEventListener('click', () => this.show(el))
        });
        this.initDialog();

    }

    initDialog() {
        this.dialog = $(document.querySelector(".js-talsperre-dialog-container")).dialog({
            autoOpen: false,
            modal: true,
            width: 740,
            title: "Talsperrensteuerung",
            height: 350,
            maxHeight: 540
        });
        if (document.body.classList.contains('hvd')) {
            const _this = this;
            this.dialog.find('.drpTextbausteine').selectmenu({
                change: async function (event, ui) {
                    if ((<any>ui.item).value === '') {
                        _this.dialogFields.description.innerHTML = '';
                        return;
                    }
                    let blockData = {
                        data: {
                            type: 'get',
                            id: <number>(<any>ui.item).value,
                        }
                    };
                    const result = await fetchPOST('/Handler/HvD/Textblock', blockData.data, false);
                    _this.dialogFields.description.innerHTML = result;
                }
            });
        }
        this.dialogFields = {
            pegelId: this.dialog.find('[name="talsperre-info-pegel"]'),
            threshold: this.dialog.find('[name="threshold"]'),
            description: this.dialog.find('.ckedit')[0]
        };

        this.dialog.find('.js-btn-cancel')[0].addEventListener('click', async () => {
            this.dialog.dialog('close');
        });

        this.dialog.find('.js-btn-save')[0].addEventListener('click', async () => {
            let itemData: ITalsperreData = {
                stationId: this.talsperreId,
                pegelId: this.dialogFields.pegelId.find(':selected').data().id,
                threshold: parseInt(<string>this.dialogFields.threshold.val()),
                description: this.dialogFields.description.innerHTML
            };

            const result = await fetchPOST('/?ajax=TalsperreControl&action=update&id=' + this.talsperreId + '-T', { data: JSON.stringify(itemData) }, false);
            if (result === 'OK') {
                window.tools.toast('Talsperrensteuerung', 'Daten gespeichert');
                this.dialog.dialog('close');
            }
        });

        this.dialog.find('.pegel-dropdown').selectmenu({
            change: function (event, ui) {
                $(this).prev().prev().val($((<any>ui.item).element[0]).attr('data-id'));
                $(this).prev().val($((<any>ui.item).element[0]).val());
                var cb = $(this).attr('data-callback');
                if (cb !== undefined && cb.length > 0) {
                    eval(cb);
                }
                document.dispatchEvent(new CustomEvent('PegelDropDown:change', { detail: { jqItem: ui } }));
            }
        });
    }



    async show(el) {
        this.talsperreId = el.querySelector('i').dataset.stationId;
        const result = await fetchJSON('/?ajax=TalsperreControl&id=' + this.talsperreId + '-T');
        if (result.length) {
            this.dialogFields.description.innerHTML = result[0].description;
            this.dialogFields.description.dispatchEvent(new Event('change'));
            this.dialogFields.threshold.val(result[0].threshold);
            this.dialogFields.pegelId.find('[data-id="' + result[0].pegelId + '"]').prop('selected', true);
            this.dialog.find('.pegel-dropdown').selectmenu('refresh');
        }
        this.dialog.find('[data-name="station_id"]').val(this.talsperreId);
        this.dialog.show();
        this.dialog.dialog("open");
        this.dialog.find('.ui-widget').width('99%');

    }
}
